import { render } from "./PaymentReceiptSheet.vue?vue&type=template&id=5f045864&scoped=true"
import script from "./PaymentReceiptSheet.vue?vue&type=script&lang=js"
export * from "./PaymentReceiptSheet.vue?vue&type=script&lang=js"

import "./PaymentReceiptSheet.vue?vue&type=style&index=0&id=5f045864&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f045864"]])

export default __exports__